// @ts-ignore
import MicRecorder from 'mic-recorder-to-mp3';
/**
 * Record an audio stream
 */
export const createAudioRecorder = () =>
  new Promise((resolve, reject) => {
    try {
      const recorder = new MicRecorder({
        bitRate: 128
      });

      // start recording method
      // tslint:disable-next-line:no-shadowed-variable
      const start = async () => {
        try {
          await recorder.start();
        } catch (error) {
          return  null;
        }
      };

      // stop recording method
      // tslint:disable-next-line:no-shadowed-variable
      const stop = async () => {
        try {
          const [buffer, blob] = await recorder.stop().getMp3();
          return {
            audioBlob: blob,
            audioURL: URL.createObjectURL(blob)
          };
        } catch (error) {
          return  null;
        }
      };

      return resolve({ start, stop });
    } catch (error) {
      // handle a possible rejection: pass it forward
      return reject(error);
    }
  });

export const elapsedTime = (time: number) => {
  const t = Math.trunc(time);
  const mins = Math.floor(t / 60);
  const secs = t % 60;
  let minStr = mins.toString();
  let secStr = secs.toString();
  if (mins < 10) {
    minStr = '0' + minStr;
  }
  if (secs < 10) {
    secStr = '0' + secStr;
  }
  return minStr + ':' + secStr;
};
